module.exports = "/images/vendor/flag-icon-css/flags/1x1/sa.svg?135d0c86322f6763fb5631794b8af510";